import { merge } from "lodash-es";
import { sharedTranslations } from "../../shared-translations.js";
import { sunsetSpecificTranslations, type ISunsetSpecificTranslations } from "../sunset/index.js";

export const zaptravelSpecificTranslations = {
  "client-verification": {
    "phone-input-label": "Phone number",
    "terms-and-conditions":
      "By clicking “Get Code via SMS”, you agree to our <terms>Terms</terms> and receive marketing messages, which may be sent by an automated system. Rates may apply. Purchasing doesn’t require consent.",
    "header-text": "Unlock Exclusive Deals",
    "helper-text":
      "We offer special rates to verified customers. Confirm you're not a bot in seconds, and amazing deals are yours!",
    "submit-button-text": "Get the code via SMS",
    "enter-sms-code": "Enter the SMS code",
    "sent-number-message": "We sent it to: ",
    "verifying-sms-code": "Verifying your code",
    "change-number": "Change number",
    "phone-otp-label": "SMS code",
    "timer-label": "Resend in",
    "resend-the-code": "Resend the code",
    "enter-code-label": "Enter or paste {digits}-digit code.",
    "successfully-verified": "Verification successful. Best deals unlocked!",
  },
  auth: {
    "weak-auth": {
      modal: {
        "alternative-login-text": "or",
        "alternative-login-button-label": "log in using SMS code",
      },
    },
  },
  "html-metadata": {
    "brand-name": "ZapTravel",
  },
} as const;

export type IZaptravelSpecificTranslations = typeof zaptravelSpecificTranslations & ISunsetSpecificTranslations;

const zaptravelTranslations = merge({}, sharedTranslations, sunsetSpecificTranslations, zaptravelSpecificTranslations);

export const translations = {
  dictionary: zaptravelTranslations,
  language: "EN",
};
